import styled, {css, keyframes} from 'styled-components';
import React from 'react';
import { basicColor, radius, transition } from '@/styles/template';
import Tooltip from '../../atoms/UI/Tooltip/Tooltip'

type PropsType = {
    percent?: number
    wrongPercent?: number
    accent?: boolean
    secondary?: boolean
    ref?: any
    big?: boolean
    transparent?: boolean
    children?: any
}

type WrongPropsType = {
    wrong?: number
}

const Wrap = styled.div<PropsType>`
    width: 100%;
    position: relative;
    height: 2px;
    border-radius: ${radius.normal};

    ${({ theme }) => theme && css`
        background: ${theme.title === 'dark' ? theme.color.Overlay : theme.color.LightItem};
    `}
    
    ${({ transparent, theme }) => transparent && css`
        background: none;
    `}

    ${({ big }) => big && css`
        height: 1rem;
        border-radius: 0;
    `}
`;

const barProperties = css`
    transition: ${transition.fastEnd};  
    transition-property: all;   
    animation-duration: 1s;
    border-radius: 1rem;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
`;

const wrongAnimation = (wrong: any) => keyframes`
    0%   { width: 0;}
    100% { width: ${wrong}%; }
`;

const rightAnimation = (rightPercent: any) => keyframes`
    0%   { width: 0;}
    100% { width: ${rightPercent}%; }
`;

const Percent = styled.div<PropsType>`
    height: 3px;
    ${barProperties};
    width: 0; /* Установите начальное значение */
    animation: ${({ percent }) => percent !== undefined ? rightAnimation(percent) : 'none'} 1s forwards;
    background-color: ${basicColor.primary};

    ${({ big, percent }) => big && css`
        animation: ${props => rightAnimation(percent)};
        width: ${percent}%;
        height: inherit;
        border-radius: 0 1rem 1rem 0;
        background-color: ${percent && percent <= 60 && percent >= 30 ? basicColor.accent :
            percent && percent < 30 ? basicColor.white :
                percent && percent > 60 ? basicColor.secondary : basicColor.white};
    `}

    ${({ accent }) => accent && css`
        background: ${basicColor.accent};
    `}

    ${({ secondary }) => secondary && css`
        background: ${basicColor.secondary};
    `}
`;

const Wrong = styled.div<WrongPropsType>`
    height: 3px;
    ${barProperties};
    animation-name: ${props => wrongAnimation(props.wrong)};
    width: ${({ wrong }) => wrong}%;
    background: ${basicColor.red};
`;

const ProgressTooltip = styled(Tooltip)<PropsType>`
    left: ${ ({ percent }) => percent}%;
`;

const Progress: React.FC<PropsType> = props => {
    const { children, ...restProps } = props;
    let wrong;

    if (props.percent && props.wrongPercent) {
        wrong = props.percent + props.wrongPercent;
    } else if (props.wrongPercent) {
        wrong = (props.wrongPercent);
    }

    return (
        <Wrap  {...restProps}>
            {(props.wrongPercent || props.wrongPercent !== 0) && <Wrong wrong={wrong} />}
            <Percent {...restProps} />
            { children && <ProgressTooltip arrowUp percent={props.percent} visible={children}>{children}</ProgressTooltip>}
        </Wrap>
    )
}

export default Progress;